
export const PartnerShipLevel  = {

  INCLUSIVE:  {text: 'Inclusion', value: 'inclusive'},

  INCLUSIVE1:  {text: 'Partenaire', value: 'partner'},

}
